module.exports = __webpack_public_path__ + "img/violations_3.b314055.jpg?v=1750755973023";